import React, { useState } from 'react';
import Button from 'ui/Button';
import { getStartTime } from '../state/helpers';
import '../styles/pool-details.css';
import { detectMobile, formatDate } from '../../../utils/UiHelper';
import copyIcon from './../../../images/icons/copy.svg';

const PoolDetailsHeader = ({ pool, status }) => {
    const [copy, setCopy] = useState(false);
    return (
        <div className="pool-details-header-container">
            <div className="pool-details-header-wrapper">
                <div className="pool-details-header-title">
                    {pool?.poolTemplate?.name}
                </div>
                <div className="pool-details-header-date capitalize">
                    {/*{status === 'loading' ? '' : getStartTime(pool)}*/}
                    {status === 'loading' || !pool?.startTime
                        ? ''
                        : formatDate(pool.startTime, 'dddd [D.] DD.MM.YY')}
                </div>
            </div>
            <div className={'pool-details-wrapper-buttons'}>
                <Button
                    lightBlue
                    margin="15px 0"
                    className="sk-copy-to-clipboard"
                    fontSize={detectMobile() ? '14px' : '12px'}
                    onClick={() => {
                        navigator.clipboard.writeText(window.location.href);
                        setCopy(true);
                    }}
                >
                    {!detectMobile() ? (
                        <img src={copyIcon} alt="copy icon" />
                    ) : null}
                    Kopier link til kupon
                    <div
                        className={`sk-copy-badge ${
                            copy ? 'badge-shown' : 'badge-hidden'
                        }`}
                        onTransitionEnd={() => setCopy(false)}
                    >
                        Link kopieret
                    </div>
                </Button>
            </div>
        </div>
    );
};

export default PoolDetailsHeader;
